<section class="asset-management-section">
  <ts-page-header [displaySeparationBorder]="true">
    <ng-container page-header-title>
      <p class="font-ts-header-title text-ts-header-title">Consolidated Chart of Accounts</p>
    </ng-container>
    <ng-container page-header-action-buttons>
      <section class="flex flex-row gap-2 items-center">
        <ts-button
          variant="secondary"
          icon="ts_file-import"
          (click)="importCategoryAccounts.emit()"
          [disabled]="loading()"
          >Import</ts-button
        >
        <ts-button
          variant="primary"
          icon="ts_plus"
          (click)="manageCategoryAccount.emit()"
          [disabled]="(hasUnsavedChanges | async) || loading()"
          >Add Account
        </ts-button>
      </section>
    </ng-container>
    <ng-container page-header-action-bar>
      <div class="flex flex-row gap-4 items-center w-full">
        <ts-input
          size="sm"
          class="w-1/4"
          placeholder="Search for name or description"
          [formControl]="searchTermFormControl"
          [clearable]="true"
        />

        @if (focusableCellsCoordinates().length > 0) {
          <div class="flex flex-row gap-2 items-center">
            <button class="flex justify-center items-center" mat-button (click)="nextFocusableCell('backward')">
              <ts-icon icon="chevron_left"></ts-icon>
            </button>
            <p class="text-sm">{{ focusedCellIndex() + 1 }} / {{ focusableCellsCoordinates().length }}</p>
            <button class="flex justify-center items-center" mat-button (click)="nextFocusableCell('forward')">
              <ts-icon icon="chevron_right"></ts-icon>
            </button>
          </div>
        }
      </div>
    </ng-container>
  </ts-page-header>

  <ag-grid-angular
    id="teams-grid"
    class="ag-theme-quartz"
    [rowData]="rowData"
    [treeData]="true"
    [getDataPath]="getDataPath"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (rowDragEnd)="onRowDragEnd($event)"
    (rowDragLeave)="onRowDragLeave($event)"
    (rowDragMove)="onRowDragMove($event)"
  ></ag-grid-angular>
</section>
